<template>
  <section class="customers-read-informations">
    <former-container>
      <customers-read-proposals
        key="proposals"
        :customer="customer"
      />

      <customers-read-guarantors
        key="guarantors"
        :guarantors="customer.guarantors"
      />

      <customers-read-resume
        key="resume"
        :customer="customer"
      />
    </former-container>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import CustomersReadGuarantors from '@/views/Customers/Read/Informations/Guarantors.vue';
  import CustomersReadProposals from '@/views/Customers/Read/Informations/Proposals.vue';
  import CustomersReadResume from '@/views/Customers/Read/Informations/Resume.vue';

  import FormerContainer from '@/components/Former/Container.vue';

  export default {
    name: 'CustomersReadInformations',
    components: {
      CustomersReadGuarantors,
      CustomersReadProposals,
      CustomersReadResume,
      FormerContainer,
    },
    computed: {
      ...mapState([
        'customers',
      ]),

      customer() {
        return this.customers.read.item;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
</style>
